import React, { useState } from "react";
import { CiHospital1 } from "react-icons/ci";
import { FaRegCalendar } from "react-icons/fa";
import { MdOutlineLocalPhone, MdOutlineMail, MdOutlineWorkOutline } from "react-icons/md";
import { SlLocationPin } from "react-icons/sl";
import { useNavigate } from "react-router-dom";

const tabs = ["Overview", "Qualifications", "Schedule", "Patients"];

export default function StaffView() {
  const [activeTab, setActiveTab] = useState("Overview");
  const navigate=useNavigate();

  return (
    <div
      style={{
        background: "#f8f9fa",
        minHeight: "100vh",
        color: "#222",
        margin: 0,
        padding: 0,
        display: "grid",
        gridTemplateRows: "auto 1fr", // header row + main content row
      }}
    >
      {/* Header */}
      <div
        style={{
          padding: "0.5rem",
          fontWeight: 600,
          fontSize: "1.6rem",
          display: "flex",
          alignItems: "center",
          borderBottom: "1px solid #eee",
        }}
      >
        <button
         onClick={()=>navigate(-1)}
          style={{
            marginRight: "1.4rem",
            fontSize: "1rem",
            background: "none",
            border: "none",
            cursor: "pointer",
          }}
          aria-label="Back"
        >
          &#8592;
        </button>
        <p>Staff Profile</p>
      </div>

      {/* Main Grid (2 columns) */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "330px 1fr", // left column + right column
          gap: "2rem",
          padding: "1rem",
          justifyContent: "center",
        }}
      >
        {/* Left Column */}
        <div
          style={{
            background: "#fff",
            border: "1px solid #eee",
            borderRadius: "1.15rem",
            boxShadow: "0 2px 8px #0001",
            padding: "2rem",
            textAlign: "center",
          }}
        >
          <div
            style={{
              width: "99px",
              height: "99px",
              borderRadius: "50%",
              overflow: "hidden",
              margin: "0 auto 1.2rem auto",
            }}
          >
            <img
              src="https://images.unsplash.com/photo-1511367461989-f85a21fda167?auto=format&fit=facearea&w=256&h=256&facepad=2&q=80"
              alt="Dr. Sarah Johnson"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          </div>
          <h2 style={{ fontSize: "1.4rem", margin: "0.2rem 0" }}>
            Dr. Sarah Johnson
          </h2>
          <p style={{ color: "#666", margin: "0 0 0.8rem 0" }}>Cardiologist</p>
          <div
            style={{
              background: "#15d86dff",
              color: "#fff",
              padding: "0.4em 0.7em",
              borderRadius: "1em",
              display: "inline-block",
              marginBottom: "1rem",
              fontSize:12
            }}
          >
            Active
          </div>
          <div style={{ textAlign: "left", fontSize: "1rem", lineHeight: "1.9" }}>
            <div className="my-1" style={{display:'flex',alignItems:'center',gap:5}}><MdOutlineMail /> sarah.j@clinic.com</div>
            <div className="my-1" style={{display:'flex',alignItems:'center',gap:5}}><MdOutlineLocalPhone /> 555-0101</div>
            <div className="my-1" style={{display:'flex',alignItems:'center',gap:5}}><SlLocationPin /> 123 Medical Center Drive, San Francisco, CA</div>
            <div className="my-1" style={{display:'flex',alignItems:'center',gap:5}}><FaRegCalendar /> Joined 21-Sep-2025</div>
            <div className="my-1" style={{display:'flex',alignItems:'center',gap:5}}><MdOutlineWorkOutline /> 12 years experience</div>
            <div className="my-1" style={{display:'flex',alignItems:'center',gap:5}}><CiHospital1 /> Medical Department</div>
          </div>
        </div>

        {/* Right Column */}
        <div
          style={{
            background: "#fff",
            border: "1px solid #eee",
            borderRadius: "1.15rem",
            boxShadow: "0 2px 8px #0001",
            padding: "2rem",
            display: "grid",
            gridTemplateRows: "auto auto 1fr", // title + tabs/buttons + content
          }}
        >
          {/* Title */}
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom: "1rem" }}>
          <div style={{ fontWeight: 600, fontSize: "1.25rem"}}>
            Staff Information
          </div>
          <div>
            <button className="gradient-dark-button" style={{ background: "#222", color: "#fff" }}>Edit Profile</button>
          </div>
          </div>

          {/* Tabs */}
          <div style={{ display: "flex", alignItems: "center", marginBottom: "1.5rem" }}>
            <div
              style={{
                display: "flex",
                background: "#f6f6f6",
                borderRadius: "0.5em",
                marginRight: "auto",
                padding:4,
                flex:1,
              }}
            >
              {tabs.map((tab) => (
                <button
                  key={tab}
                  style={{
                    padding: "0.5em 0.7em",
                    background: activeTab === tab ? "#fff" : "transparent",
                    border: "none",
                    borderRadius: "0.4em",
                    fontWeight: activeTab === tab ? 600 : 500,
                    color: activeTab === tab ? "#111" : "#aaa",
                    fontSize:14,
                    cursor: "pointer",
                    flex:1,
          
                  }}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab}
                </button>
              ))}
            </div>
            
          </div>

          {/* Content */}
          <div style={{ fontSize: "1.05rem" }}>
            {activeTab === "Overview" && (
              <>
                <div style={{ fontWeight: 600, fontSize: "1.085em", marginBottom: "0.7em",textDecoration:'underline' }}>Biography</div>
                <div style={{ color: "#222", marginBottom: "1.2em", fontSize: "1.01em" }}>
                  Dr. Sarah Johnson is a board-certified cardiologist with over 12 years of experience in diagnosing and treating cardiovascular conditions. She specializes in interventional cardiology and echocardiography, with a focus on preventive care. Dr. Johnson is dedicated to providing compassionate, patient-centered care and staying at the forefront of cardiac medicine.
                </div>
                <div style={{ fontWeight: 600, marginBottom: "0.6em", fontSize: "1em",textDecoration:'underline' }}>Specializations</div>
                <div style={{ marginBottom: "1.15em", display: "flex", gap: "0.5em", flexWrap: "wrap" }}>
                  <span style={{
                    display: "inline-block", background: "#f6f6f6", color: "#222",
                    borderRadius: "1.1em", padding: "0.38em 1.05em",
                    fontSize: "0.97em", fontWeight: 500, border: "1px solid #eee"
                  }}>Interventional Cardiology</span>
                  <span style={{
                    display: "inline-block", background: "#f6f6f6", color: "#222",
                    borderRadius: "1.1em", padding: "0.38em 1.05em",
                    fontSize: "0.97em", fontWeight: 500, border: "1px solid #eee"
                  }}>Echocardiography</span>
                  <span style={{
                    display: "inline-block", background: "#f6f6f6", color: "#222",
                    borderRadius: "1.1em", padding: "0.38em 1.05em",
                    fontSize: "0.97em", fontWeight: 500, border: "1px solid #eee"
                  }}>Preventive Cardiology</span>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
